import { render } from "./inventariococina.vue?vue&type=template&id=3b5cc5bf&scoped=true"
import script from "./inventariococina.vue?vue&type=script&lang=js"
export * from "./inventariococina.vue?vue&type=script&lang=js"

import "./inventariococina.vue?vue&type=style&index=0&id=3b5cc5bf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b5cc5bf"]])

export default __exports__